


































































































































































































































































import {Vue, Component, Ref} from 'vue-property-decorator';
import {Getter, Action} from "vuex-class";
import {
  Collapse,
  Througoutput,
  SelectWings,
  SpoilerWings,
  TabsWings,
  ToggleWings,
  NumberWings
} from "wings-ui-components";
import {CollapseTransition} from "vue2-transitions";
import {cloneDeep, isEqual} from "lodash";
import {LogicaSmppConnect, SmppConnectionItem, SmppConnectionItemImpl} from "@/store/settings/smpp_connections/types";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {OriginatorItem} from "@/store/settings/originators/types";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({components: {
  SelectWings,
  TabsWings,
  Througoutput,
  ToggleWings,
  Collapse,
  SpoilerWings,
  NumberWings,
  CollapseTransition,
}})
export default class SmppConnection extends Vue{
  @Ref('validator') validator: any;

  @Getter("serverNames") serverNamesList: any;

  @Action("getSmppConnectionItem") actionGetItem: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getServerNames") actionGetServerNames: any;
  @Action("saveSmppConnection") actionSave: any;
  @Action("deleteSmppConnection") actionDelete: any;
  @Action("actionLog") actionLog: any;

  defaultItem(): SmppConnectionItem {
    return new SmppConnectionItemImpl()
  }

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {};

  params = {transport: 'SMS'};
  serviceProvidersList:  any = []

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  async created(){
    await this.actionGetServerNames();

    if (this.$route.params.id) {
     try {
       this.logObject = {
         action_page: this.$route.meta.msgKey,
         action: "Viewing",
         action_status: "success",
         object_type: "SMPP connection",
         object_name: this.item.name,
         addititional_info: getTranslatedParams(this.item)
       }
       const data = await this.actionGetItem(this.$route.params.id)
       await this.actionLog(this.logObject);
       this.item = Object.assign({},this.item, data);
       this.itemSaved = cloneDeep(Object.assign({},this.item, data));
     } catch (error){
       this.actionLog({...this.logObject, action_status: "failed"});
     }
      this.serviceProvidersList = await this.actionGetServiceProviders({id: this.item.service_provider_id});
    } else {
      this.item.addConnects(this.serverNamesList)
      this.itemSaved.addConnects(this.serverNamesList)
    }
  }

  getSlotname(index:number) {
    return `tab-pane-${++index}`
  }

  back():void{
    this.$router.push('/settings/smpp_connections/');
  }

  async onSaveItem(): Promise<void> {
    const valid:boolean = await this.validator.validate();
    if (valid) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          action_status: "success",
          object_type: "SMPP connection",
          object_name: this.item.name,
          addititional_info: getTranslatedParams(this.item)
        }
        await this.actionSave(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
        throw error;
      }
    } else {
      setTimeout(() => {
        notifyError(null, this.validator.errors)
      }, 100);
      throw new Error();
    }
  }

  async onDeleteItem(): Promise<void> {
    const isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "SMPP connection",
          object_name: this.item.name,
          addititional_info: getTranslatedParams({id: this.item.id})
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  applyConnectSettings() {
    if (this.item.connects && this.item.connects.length > 0) {
      const primarySettings: LogicaSmppConnect = this.item.connects[0];
      this.item.connects = this.item.connects?.map(ls => {
        let ps = cloneDeep(primarySettings);
        ps.server_name = ls.server_name
        return ps
      }) ?? []
    }
  }
}
